require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-neutal.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-neutal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-neutal!./.cache/json/betreuungseinrichtungen-oberpullendorf-neutal.json
// module id = 985
// module chunks = 231608221292675